import { h, createContext } from 'preact';
import { useContext } from 'preact/hooks';
const ControllerContext = createContext(null);
export const ControllerProvider = ({ children, controller }) => {
    return h(ControllerContext.Provider, { value: controller }, children);
};
export const useController = () => useContext(ControllerContext);
export const withController = (Component) => (props) => {
    return h(Component, { controller: useController(), ...props });
};
